import React, { useContext, useState, useEffect } from 'react';
import ReactTable from 'Components/ReactTable/ReactTable';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    ViewBeneficiary as BENE_SELECT,
    GetSplitAmountForTransaction as GETSPLITAMOUNT
} from 'Components/Api/OnlyAPI';
import { LOGOUT } from 'ConstComponents';
import { DMTTransactionConfirmation } from 'Components/Alert/DMTTransactionConfirmation';
import { SelectDMTForReceiptForWeb as TRANSACTION_RECEIPT } from 'Components/Api/TransactionReportAPI';
import { DMTTransactionPrint } from 'Components/Print/DMTPrint';
import { MoneyTransfer as DMT_TRANSFER } from 'Components/Api/OnlyAPI';
import { BalanceContext } from 'Components/BalanceContext';
import * as Yup from 'yup';
import {
    MONEY_TRANSFER_CODE,
    MONEY_TRANSFER_OPERATOR_TRANSFER_CODE,
    MONEY_TRANSFER_OPERATOR_VERIFY_CODE,
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';
import { TransactionResponse } from 'Components/Alert/TransactionResponse';
import { useHistory } from 'react-router';
import { DMTTransactionOTPConfirmation } from 'Components/Alert/DMTTransactionOTPConfirmation';
import { DeleteBeneficiary as BENE_DELETE } from 'Components/Api/OnlyAPI';
var mobile = '';

export default function BeneficiaryList({
    senderNo,
    ActiveDMTName,
    senderName,
    setIsError,
    setSeverity,
    setLoading,
    setResponseMessage,
    formRef
}) {
    const { DashboardBalanceUpdate } = useContext(BalanceContext);
    const classes = commonStyle();
    const history = useHistory();
    const [mainColumns, setMainColumns] = useState([]);
    const [list, setList] = useState([]);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [serviceCode, setserviceCode] = useState(MONEY_TRANSFER_CODE);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    mobile = senderNo;
    const [isPin] = useState(localStorage.getItem('IsPin'));
    const [isResponseAlertOpen, setIsResponseAlertOpen] = useState(false);
    const [ResponseAlert, setResponseAlert] = useState({});
    const [printData, setPrintData] = useState(null);
    const [isPrint, setIsPrint] = useState(false);
    const [isOtpDialogOpen, setIsOtpDialogOpen] = useState(false);

    useEffect(() => {
        select();
        createColumns();
    }, [mobile]);

    const select = async () => {
        setList([]);
        setLoading(true);
        setIsError(false);

        if (senderNo === undefined) return;

        if (senderNo === '') return;

        var beneReqObj = JSON.stringify({
            SenderID: mobile
        });
        var response = await BENE_SELECT(beneReqObj);
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.data);
            return;
        }

        var data = JSON.parse(response.data);
        var filteredData = data.filter((bene) => bene.Status !== '0');
        setList(filteredData);
    };

    const GetSplitAmountForMultipleTransaction = async (request) => {
        setIsOtpDialogOpen(false);
        let jsonObj = {
            Mobile: mobile,
            BeneMobile: request.BeneMobile,
            Name: request.BeniName,
            BeniName: request.BeniName,
            SenderName: senderName,
            BankName: request.BankName,
            AccountNo: request.AccountNumber,
            IFSC: request.IFSC,
            BeneficiaryID: request.BeneficiaryID,
            SenderID: request.SenderID,
            PaymentType: request.PaymentType,
            Remark: request.Remark,
            DMTName: ActiveDMTName,
            Amount: request.Amount
        };
        setIsError(false);
        setLoading(true);

        var apirequest = JSON.stringify(jsonObj);
        var response = await GETSPLITAMOUNT(apirequest);
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            select();
            return;
        }
        var data = JSON.parse(response.data);
        let params = {
            MainRequest: jsonObj,
            DMTName: ActiveDMTName,
            OTPListRequest: data
        };
        history.push('/OADMT_SplitAmount', params);
        return;
    };

    const TransferWithOTP = async (request) => {
        let jsonObj = {
            Mobile: mobile,
            BeneMobile: request.BeneMobile,
            Name: request.BeniName,
            SenderName: senderName,
            BankName: request.BankName,
            AccountNo: request.AccountNo,
            IFSC: request.IFSC,
            BeneficiaryID: request.BeneficiaryID,
            SenderID: request.SenderID,
            PaymentType: request.PaymentType,
            RechargePin: request.RechargePin,
            Remark: request.Remark,
            DMTName: ActiveDMTName,
            Amount: request.Amount,
            OTP: request.OTP,
            OTPToken: request.OTPToken
        };
        setIsError(false);
        setLoading(true);

        var apirequest = JSON.stringify(jsonObj);

        var response = await DMT_TRANSFER(apirequest);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            var dataError = JSON.parse(response.data);
            setSeverity('error');
            setResponseMessage(dataError.Message);
            setIsError(true);
            select();
            return;
        }

        var data = JSON.parse(response.data);

        setResponseAlert(data);
        setIsResponseAlertOpen(true);
        select();
    };

    const Verify = async (values) => {
        var jsonObj = {
            BeneficiaryID: values.BeneficiaryID,
            Name: values.BeniName,
            SenderName: senderName,
            BankName: values.BankName,
            AccountNo: values.AccountNumber,
            IFSC: values.IFSC,
            SenderID: values.SenderID,
            Mobile: mobile,
            PaymentType: 'IMPS',
            Through: 'WEB',
            IsVerify: true,
            Amount: 1,
            RechargePin: values.RechargePin,
            BankID: values.BankID,
            DMTName: ActiveDMTName,
            BeneMobile: values.BeneMobile
        };

        setLoading(true);
        setIsError(false);

        var request = JSON.stringify(jsonObj);

        var response = await DMT_TRANSFER(request);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        setIsError(true);

        if (!response.status) {
            var dataError = JSON.parse(response.data);
            setSeverity('error');
            setResponseMessage(dataError.Message);

            setIsError(true);
            select();
            return;
        }

        setSeverity('success');
        var data = JSON.parse(response.data);
        setResponseMessage(data.Message);
        setIsError(true);

        if (!response.status) {
            let d = JSON.parse(response.data);
            setResponseMessage(d.Message);
            setSeverity('error');
            setIsError(true);
            select();
            return;
        }

        setResponseAlert(data);
        setIsResponseAlertOpen(true); 
        select();
    };

    const Print = ({ ID, Charge }) => {
        SelectPrintData(ID, Charge);
    };

    const SelectPrintData = async (TransactionMasterID, Charge) => {
        var req = {
            ID: TransactionMasterID
        };
        var request = JSON.stringify(req);

        const resp = await TRANSACTION_RECEIPT(request);

        if (!resp.isAuthorized) LOGOUT();

        if (!resp.status) return;

        var data = JSON.parse(resp.data);

        data.Charge =
            Charge === undefined || Charge === null ? data.Charge : Charge;
        setPrintData(data);

        setIsPrint(true);
    };

    const MTTransferValidation = Yup.object({
        BeniName: Yup.string().required(PLEASE_PROVIDE_VALID + 'name'),
        BeneficiaryID: Yup.string().required(PLEASE_PROVIDE_VALID + 'bene'),
        SenderID: Yup.string().required(PLEASE_PROVIDE_VALID + 'sender'),
        AccountNumber: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'account no')
            .min(7, PLEASE_PROVIDE_VALID + 'account no')
            .max(20, PLEASE_PROVIDE_VALID + 'account no'),
        Amount: Yup.number()
            .required(PLEASE_PROVIDE_VALID + 'amount')
            .min(0, PLEASE_PROVIDE_VALID + 'amount')
    });

    const MTTransferConfirmation = async (values) => {
        setConfirmAlertRequest({});
        setIsAlertOpen(false);
        let SenderID = values[9];
        let RechargePin = values[7];
        if (isPin !== 'true') {
            SenderID = values[8];
            RechargePin = '';
        }
        if (RechargePin === undefined) {
            RechargePin = '';
        }
        let jsonObj = {
            BeneficiaryID: values[0],
            BeniName: values[1],
            BankName: values[2],
            AccountNumber: values[3],
            IFSC: values[4],
            Amount: values[6],
            BeneMobile: values[11],
            RechargePin: RechargePin,
            SenderID: SenderID,
            OperatorID: MONEY_TRANSFER_OPERATOR_TRANSFER_CODE,
            ServiceID: MONEY_TRANSFER_CODE
        };
        setIsError(false);

        var errorValidation = false;

        await MTTransferValidation.validate(jsonObj).catch(function (err) {
            errorValidation = true;
            setSeverity('error');
            setResponseMessage(err.message);
            setIsError(true);
            return;
        });

        if (errorValidation === true) return;

        setIsAlertOpen(true);
        setConfirmAlertRequest(jsonObj);
    };

    const VerifyConfirmation = async (values) => {
        setConfirmAlertRequest({});
        let SenderID = values[9];
        let RechargePin = values[7];
        if (isPin !== 'true') {
            SenderID = values[8];
            RechargePin = '';
        }

        if (RechargePin === undefined) {
            RechargePin = '';
        }
        let jsonObj = {
            BeneficiaryID: values[0],
            BeniName: values[1],
            BankName: values[2],
            AccountNumber: values[3],
            IFSC: values[4],
            BankID: values[12],
            Amount: 1,
            RechargePin: RechargePin,
            SenderID: SenderID,
            OperatorID: MONEY_TRANSFER_OPERATOR_VERIFY_CODE,
            ServiceID: MONEY_TRANSFER_CODE,
            BeneMobile: values[11]
        };

        var errorValidation = false;

        await MTTransferValidation.validate(jsonObj).catch(function (err) {
            errorValidation = true;
            setSeverity('error');
            setResponseMessage(err.message);
            setIsError(true);
            return;
        });

        if (errorValidation === true) return;

        setIsAlertOpen(true);
        setConfirmAlertRequest(jsonObj);
    };

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'BeneficiaryID',
            srno: true
        });

        columns.push({
            label: <b>Beneficiary Name</b>,
            name: 'Name'
        });

        columns.push({
            label: <b>Bank Name</b>,
            name: 'BankName',
            hide: true
        });

        columns.push({
            label: <b>Account Number</b>,
            name: 'AccountNo'
        });
        columns.push({
            label: <b>IFSC</b>,
            name: 'IFSC'
        });

        columns.push({
            label: <b>Verified</b>,
            name: 'IsVerified',
            buttonTitle: 'Verify',
            buttonOrLabel: true,
            callback: (values) => {
                VerifyConfirmation(values);
            }
        });

        columns.push({
            label: <b>Amount (₹)</b>,
            name: 'Amount',
            editableWithNumberOnly: true,
            length: 6
        });

        if (isPin === 'true') {
            columns.push({
                label: <b>Pin</b>,
                name: 'RechargePin',
                editableWithPinOnly: true,
                length: 4
            });
        }
        columns.push({
            label: <b>Action</b>,
            name: 'BeneficiaryID',
            transfer: true,
            buttonTitle: 'Transfer',
            callback: (value) => {
                MTTransferConfirmation(value);
            }
        });
        columns.push({
            label: <b>Delete</b>,
            name: 'BeneficiaryID',
            icon: 'DeleteIcon',
            iconButtonWithRow: true,
            callback: (value) => {
                Delete(value);
            }
        });
        columns.push({
            label: 'BeneficiaryID',
            name: 'BeneficiaryID',
            hide: true
        });

        columns.push({
            label: 'SenderID',
            name: 'SenderID',
            hide: true
        });

        columns.push({
            label: 'BankID',
            name: 'BankID',
            hide: true
        });

        columns.push({
            label: 'BeneMobile',
            name: 'BeneMobile',
            hide: true
        });
        setMainColumns(columns);
    };

    const Delete = async (values) => {
        var jsonObj = {
            BeneficiaryID: values[0],
            AccountNumber: values[3],
            IFSC: values[4],
            MobileNumber: mobile
        };
        setLoading(true);
        setIsError(false);

        var request = JSON.stringify(jsonObj);

        var response = await BENE_DELETE(request);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();
        setIsError(true);
        setResponseMessage(response.data);
        if (!response.status) {
            setSeverity('error');
            select();
            return;
        }

        setSeverity('success');
        select();
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const sendCallback = (data) => {
        setIsResponseAlertOpen(false);

        setSeverity('success');
        if (data.Status === 'FAILURE') {
            setSeverity('error');
            setResponseMessage(data.Message);

            setIsError(true);
        }
    };

    if (senderNo === undefined || senderNo === null || senderNo.length <= 5) {
        return null;
    }

    return (
        <>
            <h2 className={classes.PaperHead_h2}>Beneficiaries</h2>
            <ReactTable data={list} columns={mainColumns} />

            {isAlertOpen && (
                <DMTTransactionConfirmation
                    isOpen={isAlertOpen}
                    ActiveDMTName={ActiveDMTName}
                    title="Domestic Money Transfer"
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsAlertOpen(false);
                        if (
                            parseInt(request.ServiceID) ===
                                MONEY_TRANSFER_CODE &&
                            parseInt(request.OperatorID) ===
                                MONEY_TRANSFER_OPERATOR_TRANSFER_CODE
                        ) {
                            GetSplitAmountForMultipleTransaction(request);
                        }

                        if (
                            parseInt(request.ServiceID) ===
                                MONEY_TRANSFER_CODE &&
                            parseInt(request.OperatorID) ===
                                MONEY_TRANSFER_OPERATOR_VERIFY_CODE
                        ) {
                            Verify(request);
                        }
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                        select();
                    }}
                />
            )}

            {isOtpDialogOpen && (
                <DMTTransactionOTPConfirmation
                    isOpen={isOtpDialogOpen}
                    ActiveDMTName={ActiveDMTName}
                    title="Domestic Money Transfer"
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsOtpDialogOpen(false);
                        TransferWithOTP(request);
                    }}
                    negativeButtonClick={() => {
                        setIsOtpDialogOpen(false);
                        select();
                    }}
                />
            )}

            {isResponseAlertOpen && (
                <TransactionResponse
                    isOpen={isResponseAlertOpen}
                    isPrint={true}
                    title={ResponseAlert.Status}
                    ServiceID={serviceCode}
                    request={ResponseAlert}
                    OkButtonClick={(request) => {
                        sendCallback(ResponseAlert);
                    }}
                    PrintButtonClick={() => {
                        setIsResponseAlertOpen(false);
                        Print({
                            ...ResponseAlert,
                            ID: ResponseAlert.VendorID
                        });
                    }}
                />
            )}

            {isPrint && (
                <DMTTransactionPrint
                    isOpen={isPrint}
                    title="Transaction Print"
                    request={printData}
                    positiveButtonClick={() => {
                        setIsPrint(false);
                        DashboardBalanceUpdate();
                    }}
                    negativeButtonClick={() => {
                        setIsPrint(false);
                    }}
                />
            )}
        </>
    );
}
